import { z } from 'zod';

export const massagerForgotPasswordFormSchema = z.object({
  clinic_number: z.string().trim().min(1, '治療院IDは必須です。'),
  login_id: z.string().trim().min(1, '施術者ログインIDは必須です。'),
});

export type MassagerForgotPasswordFormData = z.infer<typeof massagerForgotPasswordFormSchema>;
